import {ComponentStore} from '@ngrx/component-store';
import {Injectable} from '@angular/core';
import {ReportCardParametersDimensionsState} from './report-table-row-parameters-dimensions';
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {DimensionComponentObject, DimensionComponentObjects} from '../../../../../../shared/classes/dimension-component-object';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../../../shared/store/store';
import {filter, tap} from 'rxjs/operators';
import {selectDimensionComponentObjects, selectDimensionsLoaded} from '../../../../../../shared/store/selectors';

@Injectable()
export class ReportTableRowParametersDimensionsStore extends ComponentStore<ReportCardParametersDimensionsState> {
  public readonly state$: Observable<ReportCardParametersDimensionsState> = this.select((state: ReportCardParametersDimensionsState): ReportCardParametersDimensionsState => state);
  public readonly dimensions$: Observable<DimensionComponentObjects> = this.select((state: ReportCardParametersDimensionsState): DimensionComponentObjects => state.dimensions);
  public readonly dimension$: Observable<DimensionComponentObject | undefined> = this.select((state: ReportCardParametersDimensionsState): DimensionComponentObject | undefined => state.dimension);
  public readonly numberOfDimensions$: Observable<number> = this.select((state: ReportCardParametersDimensionsState): number => state.numberOfDimensions);
  public readonly enable$: Observable<boolean> = this.select((state: ReportCardParametersDimensionsState): boolean => state.enable);

  private readonly _dimensionsLoaded: Observable<boolean> = this._store.select(selectDimensionsLoaded);
  private readonly _dimensionComponentObjects: Observable<DimensionComponentObjects> = this._store.select(selectDimensionComponentObjects);

  private readonly _init: (params: Array<string>) => void = this.effect((params$: Observable<Array<string>>): Observable<[DimensionComponentObjects, boolean]> => params$.pipe(
    switchMap((params: Array<string>) => this._dimensionComponentObjects.pipe(
      withLatestFrom(this._dimensionsLoaded),
      filter(([_, loaded]: [DimensionComponentObjects, boolean]): boolean => loaded),
      tap(([dimensionComponentObjects]: [DimensionComponentObjects, boolean]): void => {
        const dimensionComponentObjectsFound: DimensionComponentObjects = params.reduce((output: DimensionComponentObjects, dimension: string) => {
          const dimensionComponentObject: DimensionComponentObject = dimensionComponentObjects
            .find((dimensionComponentObject: DimensionComponentObject): boolean => dimensionComponentObject.payload.attributes.slug === dimension);

          if (dimensionComponentObject) {
            output.push(dimensionComponentObject);
          }

          return output;
        }, []);

        this.patchState({
          dimensions: dimensionComponentObjectsFound,
          dimension: dimensionComponentObjectsFound[0],
          numberOfDimensions: dimensionComponentObjectsFound.length && dimensionComponentObjectsFound.length - 1 || 0,
          enable: dimensionComponentObjectsFound.length > 0
        });
      })
    ))
  ));

  constructor(
    private readonly _store: Store<AppState>
  ) {
    super({
      dimensions: [],
      dimension: undefined,
      numberOfDimensions: 0,
      enable: false
    });
  }

  public init(dimensions: Array<string>): void {
    this._init(dimensions);
  }

}
